import React, { Component } from 'react';
import { Container, FormGroup, Input, Label } from 'reactstrap';

import { FormattedMessage, injectIntl } from "react-intl";

import ContentLoader from "../../components/ContentLoader";
import BlogPageCard from "../../components/portfolio/BlogPage/BlogPageCard";
import GiveMeMoreButton from "../../components/portfolio/BlogPage/GiveMeMoreButton";
import Masonry from 'react-masonry-css';
import NewsletterSubscription from "../../components/portfolio/BlogPage/NewsletterSubscription";
import Picture from '../../components/Picture'
import pick from 'lodash/pick'
import { storage } from '../../helpers/storage'
import MetaTags from '../../components/SEO/MetaTags'
import { handlePublicRequestError, Request } from '../../helpers/request'
import { withRouter } from 'react-router-dom'
import debounce from 'lodash/debounce'
import { addLocalePrefix } from '../../components/Routes/LocaleLink'
import { FILTERS_KEY_BLOG_PAGE } from '../../providers/TemporaryFiltersProvider'

const filtersInitialState = {
    keywords: null,
}

class BlogPage extends Component {
    state = {
        ...filtersInitialState,
        categories: null,
        data: [],
        loading: false,
        page: 1,
        current_page: null,
        last_page: null,
    };

    constructor(props) {
        super(props);
        this.fetchDebounce = debounce(() => this.fetch(false), 250)
    }

    componentDidMount() {
        this.fetchCategories();
        const filters = storage.getItem(FILTERS_KEY_BLOG_PAGE)
        if (filters) {
            this.setState(JSON.parse(filters), () => this.fetch(false))
        } else {
            this.fetch(false);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match?.params?.category !== this.props.match?.params?.category) {
            this.fetch(false);
        }
    }

    fetchCategories() {
        this.setState({ loading: true });

        Request.get('categories')
            .then((categories) => {
                const categoryOptions = categories.data.map((category) => ({
                    value: category.slug,
                    label: category.name
                }))
                this.setState({ categories: categoryOptions, loading: false });
            })
            .catch((e) => {
                handlePublicRequestError(e);
                this.setState({ loading: false });
            });
    }

    setStateAndFetch(newState) {
        const statePick = pick(this.state, Object.keys(filtersInitialState))
        const filters = { ...statePick, ...newState, page: 1 }
        storage.setItem(FILTERS_KEY_BLOG_PAGE, JSON.stringify(filters))
        this.setState({ ...newState, page: 1 }, () => this.fetch(false));
    }

    fetch(concat = true, offset = null) {
        const { match } = this.props

        this.setState({ loading: true });
        const params = [
            'page=' + this.state.page,
            match?.params?.category && '&categories=' + match?.params?.category,
            this.state.keywords && '&keywords=' + this.state.keywords,
        ].filter(Boolean).join('')

        Request.get('articles?' + params)
            .then((articles) => {
                let { data } = this.state;
                this.setState({
                    data: concat ? data.concat(articles.data) : articles.data,
                    loading: false,
                    current_page: articles.current_page,
                    last_page: articles.last_page,
                }, () => offset ? window.scrollTo(0, offset) : null);
            })
            .catch((e) => {
                handlePublicRequestError(e);
                this.setState({ loading: false });
            });
    }

    handleMore() {
        this.setState({ page: this.state.page + 1 }, () => this.fetch(true, window.pageYOffset));
    }

    handleCategoryChange(category) {
        const { history } = this.props

        history.push(addLocalePrefix(`/blog/${category}`))
    }

    handleKeywordChange(keywords) {
        this.setState({ keywords })
        this.fetchDebounce()
    }

    breakpointColumnsObj = {
        default: 4,
        991: 2,
        768: 1,
    };

    render() {
        const { intl } = this.props;

        return (
            <div className="blog-page">

                <MetaTags page="blog" />

                <section className="listing-blog">
                    <Container>
                        <div className="blog-listing-head">
                            <div className="blog-img">
                                <Picture
                                    src={require("../../../images/blog.png")}
                                    webp={require("../../../images/blog.webp")} />
                            </div>
                            <h1>
                                <FormattedMessage
                                    id="portfolio.blog.bigtitle"
                                    defaultMessage="Les actualités de la Tech et du Digital sur notre blog"
                                />
                            </h1>
                            <h2>
                                <FormattedMessage
                                    id="portfolio.blog.title"
                                    defaultMessage="Toute l’actualité du digital"
                                />
                            </h2>
                            <div className="field-wrap p-0">
                                <FormGroup className='w-100'>
                                    <Label className='text-left'>
                                        <FormattedMessage
                                            id="myurban.articles.index.search.label"
                                            defaultMessage="Recherche"
                                        />
                                    </Label>
                                    <Input type="text"
                                           className="input-field pl-0"
                                           placeholder={
                                               intl.formatMessage({
                                                   id: "myurban.articles.index.search.placeholder",
                                                   defaultMessage: "Par titre, auteur, catégorie..."
                                               })
                                           }
                                           value={this.state.keywords || ''}
                                           onChange={(e) => this.handleKeywordChange(e.target.value)}
                                    />
                                </FormGroup>
                            </div>
                            <div className="check-list">
                                {this.renderOptions()}
                            </div>
                        </div>

                        {this.renderGallery()}

                        <div className="blog-listing-head">
                            <NewsletterSubscription />
                        </div>

                    </Container>
                </section>
            </div>
        )
    }

    renderGallery() {
        const { data } = this.state;

        if (!data)
            return <ContentLoader />;

        return (
            <div className="gallery">
                <Masonry className={'blog-list'} columnClassName="masonry-grid-column"
                         breakpointCols={this.breakpointColumnsObj}>
                    {
                        data.map((card, key) => {
                            return (
                                <BlogPageCard
                                    data={card}
                                    key={key}
                                />
                            )
                        })
                    }
                </Masonry>

                <GiveMeMoreButton
                    onClick={() => this.handleMore()}
                    disabled={this.state.current_page === this.state.last_page}
                    loading={this.state.loading}
                />
            </div>
        )
    }

    renderOptions() {
        const { categories } = this.state
        if (!categories || categories.length === 0) return null;

        const isCategoryOptionsChecked = (option) => {
            return option.value === this.props.match?.params?.category
        }

        return categories.map((option, key) => {
            return (
                <FormGroup key={key}>
                    <Label className="checkbox-warning">
                        <Input
                            type="checkbox"
                            name="radio-btn"
                            value={option.value}
                            checked={isCategoryOptionsChecked(option)}
                            onChange={e => this.handleCategoryChange(e.target.value)}
                        />
                        <span>{option.label}</span>
                    </Label>
                </FormGroup>
            )
        })
    }
}

export default withRouter(injectIntl(BlogPage));
